import { Violation, ViolationImportance, ViolationType } from 'konect-model';
import { MDBBtn, MDBBtnGroup } from 'mdb-react-ui-kit';
import React, { useEffect, useState, useContext } from 'react';
import UserControlService from '../../services/user-control-service';
import { AppContext } from '../App';

interface ViolationEntryProps {
    violation: Violation,
    onChange: () => void,
    onIgnore: () => void,
    onRemove:() => void
}

export const VIOLATION_COLOR = {
    [ViolationType.CHOSEN_ATTRIBUTE]: "green",
    [ViolationType.ADDITIONAL_INFORMATION]: "blue",
    [ViolationType.INCONSISTENCY]: "orange",
    [ViolationType.SIMPLICITY_COLOR]: "purple",
    [ViolationType.SIMPLICITY_SHAPE]: "#e6a749",
    [ViolationType.CUSTOM]: "red"
}

export const VIOLATION_LINK = {
    [ViolationType.CHOSEN_ATTRIBUTE]: 4,
    [ViolationType.ADDITIONAL_INFORMATION]: 4,
    [ViolationType.INCONSISTENCY]: 4,
    [ViolationType.SIMPLICITY_COLOR]: 9,
    [ViolationType.SIMPLICITY_SHAPE]: 9,
    [ViolationType.CUSTOM]: 4
}

export default function ViolationEntry(props: ViolationEntryProps) {
    const violation = props.violation;
    const [importance, setImportance] = useState(violation.importance);
    const {setNavState} = useContext(AppContext);

    useEffect(() => {
        setImportance(props.violation.importance)
    }, [props])

    const updateImportance = (importance: ViolationImportance) => {
        UserControlService.update();
        violation.importance = importance;
        setImportance(importance);
        props.onChange && props.onChange()
    }

    return <div className={'violation' + (violation.importance <= 0 ? " ignore" : "")}>
        <div style={{display: "flex", width: "100%", justifyContent: "space-between"}}>
        <div>
            <span className='violation-name'>{violation.name}</span> <br />
            <span className='violation-type' style={{ backgroundColor: VIOLATION_COLOR[violation.type] }}>{violation.type}</span>
        </div>
        <span style={{display: "flex"}}>
        <div style={{margin: "0 10px"}}>
        <MDBBtnGroup size="sm">
            <MDBBtn href='#' style={importance < 1 && importance > 0 ? {backgroundColor: "var(--mdb-dark)", color: "white"} : {}} onClick={() => {updateImportance(ViolationImportance.LOW)}}>Low</MDBBtn>
            <MDBBtn href='#' style={importance === 1 ? {backgroundColor: "var(--mdb-dark)", color: "white"} : {}} onClick={() => {updateImportance(ViolationImportance.NORMAL)}}>Normal</MDBBtn>
            <MDBBtn href='#' style={importance > 1 ? {backgroundColor: "var(--mdb-dark)", color: "white"} : {}} onClick={() => {updateImportance(ViolationImportance.HIGH)}}>High</MDBBtn>
        </MDBBtnGroup>
        <div style={{fontWeight: "bold", fontSize: "0.75em", marginTop: "0.25rem", color: "gray", textAlign: "center"}}>IMPORTANCE</div>
        </div>
        <i className={"fas fa-ban accept-modal-button base "} title="Ignore Violation" onClick={(e) => {props.onIgnore()}} style={{display: "inline-flex", fontSize: "1.25em", color: "gray"}}/>
        {violation.type === ViolationType.CUSTOM ?
         <i className={"fas fa-trash accept-modal-button base "} title="Remove Violation" onClick={props.onRemove} style={{display: "inline-flex", fontSize: "1.25em", color: "gray", marginLeft: "5px"}}/>
        :
        <i className={"fas fa-link accept-modal-button base "} title="Go to relevant step" onClick={(e) => {setNavState(VIOLATION_LINK[violation.type])}} style={{display: "inline-flex", fontSize: "1.25em", color: "gray", marginLeft: "5px"}}/>
        }
        </span>
        </div>
        <span className='violation-description'>{getDescriptionJSX(violation.description)}</span>
        {violation.ignoreReason && violation.importance <= 0 && <span className='violation-description' style={{fontStyle: "italic"}}><span style={{fontWeight: "bold"}}>Ignore Reason: </span>{violation.ignoreReason}</span>}
    </div>
}

function getDescriptionJSX(description : string) {
    const newDescription = []
    const groups = description.split('<');
    for (const group of groups) {
        const parts = group.split('>');
        if (parts.length >= 2) {
            newDescription.push(<span key={newDescription.length} style={{fontWeight: "bold"}}>{parts[0]}</span>)
            newDescription.push(<span key={newDescription.length}>{parts[1]}</span>)
        } else {
            newDescription.push(<span key={newDescription.length}>{parts[0]}</span>)
        }
    }
    return newDescription
}